import type { RootState } from '../root_reducer';
import { BUILDOUT_CRM_MODE, RETHINK_MODE } from '../../embedded_mode';

export const selectDefaultMapType = (state): string => {
  return state.ui.profile.defaultMapType || 'roadmap';
};

export const selectHasUnlimitedUnlocks = (state): boolean => state.ui.profile.hasUnlimitedUnlocks;

export const selectShowTableView = (state): boolean => state.ui.showTableView;

export const selectShowMap = (state): boolean => state.ui.showMap;

export const selectOffMarketSearch = (state): boolean => state.ui.offMarketSearch;

export const selectCallListTableView = (state): boolean => state.ui.callListTableView;

export const selectLoading = (state): boolean => state.ui.loading;

export const selectStaticCallList = (state): boolean => state.ui.staticCallList;

export const selectEmbeddedMode = (state: RootState): typeof RETHINK_MODE | typeof BUILDOUT_CRM_MODE | '' => state.ui.embeddedMode || '';
